/**
 * The maximum depth of comments to render.
 *
 * This is used to prevent too deeply nested comments from looking bad until we have a better UI to handle this.
 */
export const MAX_DEPTH = 4
